import React from "react";
import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <div className="min-h-screen bg-brand text-primary-brand">
      <nav className="flex items-center justify-between px-6 md:px-12 py-6 border-b border-brand">
        <div className="font-serif-elegant text-2xl tracking-wide">BiGeldi</div>
        <div className="flex items-center gap-6">
          <Link to="/dugun/beyza-nur-onur-baran" data-testid="landing-demo-link" className="text-xs uppercase tracking-luxury text-secondary-brand hover:text-accent-brand transition">Demo Davetiye</Link>
          <Link to="/admin/login" data-testid="landing-admin-link" className="btn-ghost">Yönetim</Link>
        </div>
      </nav>

      <section className="max-w-5xl mx-auto px-6 md:px-12 py-24 md:py-40 text-center">
        <div className="eyebrow reveal">— BiGeldi Dijital Davetiye —</div>
        <h1 className="font-serif-elegant text-5xl md:text-7xl lg:text-8xl font-light mt-6 leading-[0.95] reveal reveal-delay-1">
          Aşkınızı<br/><em className="italic text-accent-brand">zarif</em> bir hikâyeye dönüştürün.
        </h1>
        <p className="mt-8 max-w-2xl mx-auto text-secondary-brand leading-relaxed reveal reveal-delay-2">
          Çiftinize özel, mobil öncelikli premium dijital davetiye mikrositeleri.
          Geri sayım, RSVP, galeri, hikâye ve QR paylaşım — hepsi tek bir zarif deneyimde.
        </p>
        <div className="mt-12 flex items-center justify-center gap-4 reveal reveal-delay-3">
          <Link to="/dugun/beyza-nur-onur-baran" className="btn-primary" data-testid="landing-view-demo-btn">Demo Davetiyeyi Gör</Link>
          <Link to="/admin/login" className="btn-ghost" data-testid="landing-manage-btn">Davetiye Oluştur</Link>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 md:px-12 pb-24 grid md:grid-cols-3 gap-8">
        {[
          {t:"Sinematik Açılış", d:"Zarif zarfın açılışıyla başlayan cinematic bir karşılama."},
          {t:"Canlı Geri Sayım", d:"Düğün gününüze kadar her saniye zarif bir şekilde işler."},
          {t:"RSVP & Anılar", d:"Katılım bildirimi ve konuklardan gelen anılar tek yerde."},
        ].map((f,i)=> (
          <div key={i} className="paper-card p-8">
            <div className="eyebrow mb-3">0{i+1}</div>
            <h3 className="font-serif-elegant text-2xl mb-2">{f.t}</h3>
            <p className="text-secondary-brand text-sm leading-relaxed">{f.d}</p>
          </div>
        ))}
      </section>

      <footer className="border-t border-brand py-8 text-center text-xs tracking-luxury text-secondary-brand">
        © {new Date().getFullYear()} BiGeldi Dijital Davetiye
      </footer>
    </div>
  );
}
